module.exports = __webpack_public_path__ + "media/images/candidate-experience-mailer-new-survey-70bfc2cf24309158bb1a27e0735f1a64.png";